export function getDates(data) {
	const baselineDate = data.survey.baseline.date.shortDate;
	const exitDate = data.survey.exit.date.shortDate;
	return { baselineDate, exitDate };
}
